import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Convert provider role to display name — hides "ADMIN" from end users
export const getProviderDisplayName = (role: string, name?: string): string => {
  if (!role) return name || "Ren Power";
  const upper = role.toUpperCase();
  if (upper === "ADMIN") return "Ren Power";
  if (upper === "MANUFACTURER") return "Manufacturer";
  if (upper === "DISTRIBUTOR") return "Distributor";
  if (upper === "HOMEOWNER") return "Homeowner";
  if (upper === "RECYCLER") return "Recycler";
  return name || role;
};

// Format long titles to avoid wrapping
export const truncateText = (title: string, maxLength: number = 25) => {
  return title.length > maxLength
    ? `${title.substring(0, maxLength)}...`
    : title;
};
